import { useState, useEffect } from "react";
import "./FormContentEnd.css";
import { Question, UpdateQuestionPayload } from "effno-core";
import { useSelector } from "react-redux";
import { selectEditingForm, selectUIStates, selectViewingFormThemeSettings, setEditingForm } from "../../redux/features/appData";
import { useDispatch } from "react-redux";
import { FormSocials } from "../form-socials/FormSocials";
import { END_SETTINGS } from "../config/questionSettings";
import { apiUpdateQuestion } from "../../services/QuestionService";
import toast from "react-hot-toast";
import { toastFail, toastSuccess } from "../../config";
import { DEBOUNCE_TIME } from "../config/forms";
import { apiFormHasEdits } from "../../services/FormService";
import { Branding } from "../form-widgets/Branding";

type FormContentEndProps = {
    question: Question;
    allowSaving?: boolean;
}

export const FormContentEnd = ({question, allowSaving = true} : FormContentEndProps) => {

    const dispatch = useDispatch();

    const editingForm = useSelector(selectEditingForm);
    const viewingFormThemeSettings = useSelector(selectViewingFormThemeSettings);
    const uiStates = useSelector(selectUIStates);

    const [title, setTitle] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [settings, setSettings] = useState<any | undefined>(undefined);

    const [fontSize, setFontSize] = useState<number>(40);
    const [titleStyle, setTitleStyle] = useState<any>({width: "1ch"});
    const [descriptionStyle, setDescriptionStyle] = useState<any>({width: "1ch"});

    const [debouncedData, setDebouncedData] = useState<any | undefined>(undefined);
    const [debounceSettings, setDebounceSettings] = useState<any | undefined>(undefined);


    useEffect(() => {
        setTitle(question.title);
        setDescription(question.description);
        // setTitleStyle({width: question.title.length + 2 + "ch"})
        // setDescriptionStyle({width: question.description.length + 2 + "ch"})

        const questionSettings = JSON.parse(question.settings);
        setSettings(questionSettings);
    }, [question])

    useEffect(() => {
        setTitleStyle({
            // // width: title.length + "ch",
            // width: title.length + "2",
            // maxWidth: "90%",
            fontSize: fontSize + "px",
            // border: "1px solid green"
        });

        setDescriptionStyle({
            // width: title.length + "ch",
            // width: description.length + "2",
            // maxWidth: "90%",
            fontSize: fontSize + "px",
            // border: "1px solid green"
        });

        // if (fontSize && viewingFormThemeSettings?.font) {
        //     // Create a temporary element to measure character width
        //     let span = document.createElement('span');
        //     span.style.fontSize = `${fontSize}px`;
        //     span.style.fontFamily = viewingFormThemeSettings?.font;
        //     // span.style.position = 'absolute';
        //     span.innerText = title;
        //     span.style.whiteSpace = "pre";
        //     span.style.visibility = "hidden"
        //     // span.value = title; // write the whole title to get the width
        //     document.body.appendChild(span);
            
        //     // Get the width of the span
        //     const titleWidth = span.offsetWidth + 20;
        //     document.body.removeChild(span);
            
        //     // Calculate total width
            
        //         // const width = charWidth * title.length + 
        //         // INPUT_PADDING * 2 + INPUT_BORDER_WIDTH * 2;
        //     setTitleStyle({
        //         // width: title.length + "ch",
        //         width: titleWidth + "px",
        //         maxWidth: "100%",
        //         fontSize: fontSize + "px",
        //         // border: "1px solid green"
        //     });

        //     // Create a temporary element to measure character width
        //     span = document.createElement('span');
        //     span.style.fontSize = `${fontSize}px`;
        //     span.style.fontFamily = viewingFormThemeSettings?.font;
        //     // span.style.position = 'absolute';
        //     span.innerText = description;
        //     span.style.whiteSpace = "pre";
        //     span.style.visibility = "hidden"
        //     // span.value = title; // write the whole title to get the width
        //     document.body.appendChild(span);
            
        //     // Get the width of the span
        //     const descWidth = span.offsetWidth + 20;
        //     document.body.removeChild(span);
            
        //     // Calculate total width
            
        //         // const width = charWidth * title.length + 
        //         // INPUT_PADDING * 2 + INPUT_BORDER_WIDTH * 2;
        //     setDescriptionStyle({
        //         // width: title.length + "ch",
        //         width: descWidth + "px",
        //         maxWidth: "100%",
        //         fontSize: fontSize + "px",
        //         // border: "1px solid green"
        //     });
        // }
          
    }, [title, description, viewingFormThemeSettings]);

     // Debounce settings changes
     useEffect(() => {
        const handler = setTimeout(() => {
            if (!debounceSettings) {
                return;
            }
            setDebouncedData(debounceSettings);
        }, DEBOUNCE_TIME);

        // Clear the timeout if settings changes (i.e., user is still typing)
        return () => {
            clearTimeout(handler);
        };
    }, [debounceSettings]);

    // Effect to save the debounced data whenever it changes
    useEffect(() => {
        (async () => {
            if (!debouncedData) {
                return;
            }

            console.log("debouncedData: ", debouncedData);
            
            await handleSave();
        })()
    }, [debouncedData]);

    useEffect(() => {
        setDebounceSettings({
            title,
            description
        })
    }, [title, description])

    const updateRedux = () => {
        if (!editingForm) {
            return;
        }

        const index = editingForm.questions.findIndex((q: Question) =>  q.id === question.id);

        if (index === -1) {
            toast("Can't find question id", toastFail);
            return;
        }

        const newQuestions = [...editingForm.questions];
        newQuestions[index] = {
            ...question,
            title,
            description,
        };

        dispatch(setEditingForm({...editingForm, hasEdits: true, questions: newQuestions}));
    }

    const handleSave = async () => {
        if (!editingForm || !allowSaving) {
            return;
        }

        // update question in redux first to avoid delay lag causing issues
        updateRedux();

        const settings = question.settings ? JSON.parse(question.settings) : END_SETTINGS;

        const payload : UpdateQuestionPayload = {
            questionId: question.id,
            type: question.type,
            title: title,
            description: description,
            required: question.required,
            settings: JSON.stringify(settings),  // these don't change in this instance
            conditions: question.conditions
        }

        const newQuestion = await apiUpdateQuestion(payload);

        if (!newQuestion) {
            toast("Error saving update", toastFail);
            return;
        }

        await apiFormHasEdits(editingForm.id);
        console.log("Question updated");

        // update redux
        // const index = editingForm.questions.findIndex((q: Question) =>  q.id === question.id);

        // if (index === -1) {
        //     toast("Can't find question id", toastFail);
        //     return;
        // }

        // const newQuestions = [...editingForm.questions];
        // newQuestions[index] = newQuestion;

        // await apiFormHasEdits(editingForm.id);

        // dispatch(setEditingForm({...editingForm, hasEdits: true, questions: newQuestions}));

        // console.log("Question updated");

    }

    const maxLength = uiStates.mobileLayout ? 25 : 50;


    return (
        <div className="form-content-body">
            <div className="form-content-end">
                <div className="form-content-title" style={{width: "100%"}}>
                    <input 
                        type="text"
                        placeholder="..."
                        value={title}
                        // style={titleStyle}
                        style={{textAlign: "center"}}
                        onChange={(e) => {
                            setTitleStyle({width: e.target.value.length + 2 + "ch"})
                            setTitle(e.target.value)
                        }}
                        maxLength={maxLength}
                        width="50%"
                        data-testid="question-title"
                    />
                    {/* {question.required && <span>*</span>} */}
                </div>
                <div className="form-content-description" style={{width: "100%"}}>
                    <input 
                        type="text"
                        placeholder=""
                        value={description}
                        style={{textAlign: "center"}}
                        // style={descriptionStyle}
                        onChange={(e) => {
                            setDescriptionStyle({width: e.target.value.length + 2 + "ch"})
                            setDescription(e.target.value)
                        }}
                        maxLength={maxLength}
                        data-testid="question-description"
                    />
                </div>   

                {settings?.socialShareOn && 
                    <FormSocials />
                }

                {settings?.brandingOn &&
                    <div className="form-content-end-branding">
                        <Branding />
                    </div>
                }
            </div>

            {/* <button 
                onClick={handleSave}
                data-testid="save-question"
            >
                temp save button before debounce 
            </button> */}

        </div>
    )
}